module.exports = __webpack_public_path__ + "img/Group-4911.ea8e4ea6.svg";